import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import configVars from "../config";
import { Button, Spinner } from "react-bootstrap";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import { EditorState, ContentState, convertToRaw } from "draft-js";
import { useTranslation } from "react-i18next";
import { UPDATE_PURPOSE } from "../redux/types";

const Purpose = ({ purpose, token, boardid, board }) => {
  const [purposeContent, setPurposeContent] = useState("");
  const [purposeContentState, setPurposeContentState] = useState("");
  const [translation] = useTranslation("translations");
  const dispatch = useDispatch();
  const [isError, setIsError] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    let _purpose = purpose?.board_purpose;

    if (_purpose) {
      const contentBlock1 = htmlToDraft(_purpose);

      if (contentBlock1) {
        const contentState = ContentState.createFromBlockArray(
          contentBlock1.contentBlocks
        );
        const editorState = EditorState.createWithContent(contentState);
        setPurposeContent(editorState);
        let _contentState = convertToRaw(editorState.getCurrentContent());
        setPurposeContentState(_contentState);
      }
    }
  }, [purpose, board]);

  const handleChange = (value) => {
    setPurposeContent(value);
  };

  const _submitData = async () => {
    setIsLoading(true);
    try {
      setErrorMsg("");
      const response = await fetch(
        `${configVars.apiUrl}sustainchange/v1/update-purpose`,
        {
          method: "POST",
          headers: {
            Authorization: `Basic ${configVars.auth}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            board_id: boardid,
            token: token,
            board_purpose: draftToHtml(purposeContentState),
          }),
        }
      );

      const data = await response.json();
      if (data.status_code === 200) {
        dispatch({
          type: UPDATE_PURPOSE,
          payload: { purpose: data?.data, boardId: boardid },
        });
      } else {
        setIsError(true);
        setErrorMsg(translation("purpose_update_error_message"));
        setTimeout(() => {
          setIsError(false);
          setErrorMsg("");
        }, 3000);
      }
    } catch (error) {}
    setIsLoading(false);
  };

  return (
    <div className="w-100 shadow bg-white rounded-3 p-4 d-inline-block w-100 board-purpose-wrapper mb-3">
      <h2>
        {translation("project_purpose_heading")}{" "}
        {purpose?.purpose_updated_by ? (
          <span className="project-purpose-author">
            ({purpose?.purpose_updated_by})
          </span>
        ) : (
          ""
        )}
      </h2>
      <div>
        <Editor
          toolbarOnFocus
          toolbar={configVars?.wysiwygToolbarOptions}
          editorState={purposeContent}
          toolbarClassName="toolbarClassName"
          wrapperClassName="wrapperClassName"
          editorClassName="editor-wrapper"
          onEditorStateChange={(e) => handleChange(e)}
          onChange={(e) => setPurposeContentState(e)}
        />
        <div className="row">
          <div className="col-10">
            {isError && <span className="text-danger">{errorMsg}</span>}
          </div>
          <div className="col-2">
            <Button
              onClick={_submitData}
              disabled={isLoading}
              className="text-white rounded btn btn-sm pull-right mt-3 btn-halite-blue-light"
            >
              {isLoading ? (
                <Spinner
                  animation="border"
                  size="sm"
                  style={{ color: "#fff" }}
                />
              ) : (
                <span>{translation("purpose_update_btn")}</span>
              )}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Purpose;
